import React from 'react';
import { Navigate } from 'react-router-dom';
import constants from '../constants';
import { isTokenValid, setPostLoginPath } from '../components/utilities/authConstants';

const PrivateRoute = ({ component: Component }) => {
  // Save the current path for redirect after login (legacy key + PKCE helper).
  sessionStorage.setItem("redirect_to", window.location.pathname);

  if (sessionStorage.getItem(constants.GC_TOKEN) && isTokenValid()) {
    return <Component />;
  }

  // No valid token -> start the PKCE login flow and return here afterwards.
  setPostLoginPath(window.location.pathname);
  return <Navigate to="/purecloudlogin" replace />;
};

export default PrivateRoute;
